
const apiKey = '1525839d-007d-44d9-bf00-1753bed13b42';

export const geocodeAddress = async (address) => {
    const boundedAddress = `${address}, Дилижан`;
    const response = await fetch(`https://geocode-maps.yandex.ru/1.x/?apikey=${apiKey}&format=json&geocode=${boundedAddress}`);
    const data = await response.json();
    if (data.response.GeoObjectCollection.featureMember.length > 0) {
      const coordinates = data.response.GeoObjectCollection.featureMember[0].GeoObject.Point.pos.split(' ').map(Number).reverse();
      return coordinates;
    }
    throw new Error('Address not found');
  };
  
  export const reverseGeocode = async (coords) => {
    const response = await fetch(`https://geocode-maps.yandex.ru/1.x/?apikey=${apiKey}&geocode=${coords[1]},${coords[0]}&format=json&kind=house`);
    const address = response.data.response.GeoObjectCollection.featureMember[0].GeoObject.metaDataProperty.GeocoderMetaData.text;
    return address;
  };